import { TokenMetadataInfo } from "../types/type";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:5000';

const buildUrl = (endpoint: string) => {
  const baseUrl = BACKEND_URL.endsWith('/') ? BACKEND_URL.slice(0, -1) : BACKEND_URL;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

export const uploadImage = async (file: File): Promise<string | false> => {
  try {
    const urlResponse = await fetch(buildUrl('cloudflare/get-upload-url'), {
      method: "GET",
    });

    if (!urlResponse.ok) {
      throw new Error(`Failed to get upload URL: ${urlResponse.statusText}`);
    }

    const urlResult = await urlResponse.json();
    if (!urlResult.success || !urlResult.data.uploadURL) {
      throw new Error("Failed to get upload URL from backend");
    }

    const { uploadURL, imageId } = urlResult.data;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("uploadURL", uploadURL);

    const response = await fetch(buildUrl('cloudflare/upload-file'), {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Failed to upload file: ${response.statusText}`);
    }

    const result = await response.json();
    if (result.success && result.data.variants && result.data.variants[0]) {
      return result.data.variants[0];
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error uploading image via backend:", error);
    return false;
  }
};

export const uploadMetadata = async (metadata: TokenMetadataInfo): Promise<any> => {
  try {
    const urlResponse = await fetch(buildUrl('cloudflare/get-upload-url'), {
      method: "GET",
    });

    if (!urlResponse.ok) {
      throw new Error(`Failed to get upload URL: ${urlResponse.statusText}`);
    }

    const urlResult = await urlResponse.json();
    if (!urlResult.success || !urlResult.data.uploadURL) {
      throw new Error("Failed to get upload URL from backend");
    }

    const { uploadURL, imageId } = urlResult.data;

    const response = await fetch(buildUrl('cloudflare/upload-metadata'), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        metadata,
        uploadURL
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to upload metadata: ${response.statusText}`);
    }

    const result = await response.json();
    if (result.success && result.data.publicUrl) {
      return result.data.publicUrl;
    } else {
      throw new Error("Invalid response from backend");
    }
  } catch (error) {
    console.error("Error uploading metadata via backend:", error);
    throw error;
  }
}